import React, { isValidElement, useState } from 'react';
import { TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Fields from 'components/Fields';
import { formatPercent } from 'utils';
import TableComponents from 'components/Table';
import ModelPortfolioAllocations from 'components/ModelPortfolio/ModelPortfolioAllocations';

const useStyles = makeStyles({
  footer: {
    backgroundColor: '#c6e0f4',
    lineHeight: 'unset'
  },
  icon: {
    fontSize: '1.5rem',
    cursor: 'pointer',
    transition: '0.3s'
  },
  boldRow: {
    fontWeight: 'bold',
    '& input': {
      fontWeight: 'bold'
    }
  },
  iconsBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
});

interface Props {
  fundDetails: any;
  toggleCipFund: any;
  isFundAdded: boolean;
  isEvalue: boolean;
  risk: any;
}

const CipFund = ({
  fundDetails,
  toggleCipFund,
  isFundAdded,
  isEvalue = false,
  risk
}: Props) => {
  const [isModelPortfolioExpanded, setModelPortfolioExpanded] = useState(false);
  const classes = useStyles();
  const isModelPortfolio = !!fundDetails.model_portfolio;

  const { sector_name, name, id, fund_allocations } = isModelPortfolio
    ? fundDetails.model_portfolio
    : fundDetails.fund;

  const allocation = Number(fundDetails.allocation) * 100;

  let growthAssetPercentage = '-' as any;
  let comfortScore = '-' as any;

  if (!isEvalue) {
    if (isValidElement(risk)) {
      growthAssetPercentage = risk;
      comfortScore = risk;
    } else {
      const values = Object.values(risk)[0] as any;
      growthAssetPercentage =
        formatPercent(values?.growth_asset_percentage) || '-';
      comfortScore = `${values.ok_risk?.low} - ${values.ok_risk?.high}`;
    }
  }

  return (
    <>
      <TableRow>
        <TableComponents.TableCell width="60px">
          <Fields.CheckboxCustom
            isChecked={isFundAdded}
            onChange={() =>
              toggleCipFund(
                isModelPortfolio
                  ? fundDetails
                  : {
                      ...fundDetails.fund,
                      allocation: fundDetails.allocation
                    }
              )
            }
          />
        </TableComponents.TableCell>
        <TableComponents.TableCell
          className={isModelPortfolio ? classes.boldRow : ''}
        >
          {fundDetails.cip_threshold.display_name}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          className={isModelPortfolio ? classes.boldRow : ''}
        >
          {name}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          className={isModelPortfolio ? classes.boldRow : ''}
          width="220px"
        >
          {sector_name || '-'}
        </TableComponents.TableCell>
        {isEvalue ? (
          <TableComponents.TableCell
            className={isModelPortfolio ? classes.boldRow : ''}
          >
            {risk}
          </TableComponents.TableCell>
        ) : (
          <>
            <TableComponents.TableCell
              className={isModelPortfolio ? classes.boldRow : ''}
            >
              {growthAssetPercentage}
            </TableComponents.TableCell>
            <TableComponents.TableCell
              className={isModelPortfolio ? classes.boldRow : ''}
            >
              {comfortScore}
            </TableComponents.TableCell>
          </>
        )}
        <TableComponents.TableCell
          width="120px"
          className={isModelPortfolio ? classes.boldRow : ''}
        >
          {formatPercent(0)}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="120px"
          className={isModelPortfolio ? classes.boldRow : ''}
        >
          {formatPercent(allocation)}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="80px"
          className={isModelPortfolio ? classes.boldRow : ''}
        >
          <div className={classes.iconsBox}>
            {isModelPortfolio && (
              <ExpandMoreIcon
                className={classes.icon}
                onClick={() =>
                  setModelPortfolioExpanded(!isModelPortfolioExpanded)
                }
                style={{
                  transform: isModelPortfolioExpanded
                    ? 'rotate(180deg)'
                    : 'rotate(0)'
                }}
              />
            )}
          </div>
        </TableComponents.TableCell>
      </TableRow>
      {isModelPortfolio && isModelPortfolioExpanded && (
        <ModelPortfolioAllocations
          id={id}
          fundAllocations={fund_allocations}
          showCharges={false}
          showPerformance={false}
          withEmptyColumn
        />
      )}
    </>
  );
};

export default CipFund;
